import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, Icon, UiButton, UiText } from '@shared/ui';

import cls from './PastStartDateWarningStep.module.css';

interface ButtonsInterfaceProps {
    onChangeStatusInExploitation: () => Promise<void>;
    onSetFormModalType: () => void;
}

export const PastStartDateWarningStep = ({
    onChangeStatusInExploitation,
    onSetFormModalType,
}: ButtonsInterfaceProps) => {
    const { t } = useTranslation();

    const redirectToGantt = () => {
        window.location.assign(routable.getRoute('toSchedule'));
    };
    return (
        <>
            <CustomModal.Header>{t('PastStartDateWarningStep.Header')}</CustomModal.Header>
            <CustomModal.Body>
                <Flex direction="column" gap={8}>
                    <UiText variant="mediumPlain">
                        {t('PastStartDateWarningStep.Body.first')}
                    </UiText>
                    <UiText variant="mediumPlain">
                        {t('PastStartDateWarningStep.Body.Second')}
                    </UiText>
                </Flex>
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex direction="column" fullWidth gap={8}>
                    <UiButton
                        onClick={onSetFormModalType}
                        className={cls.buttons}
                        btnText={t('PastStartDateWarningStep.Footer.UiButton.changeDate')}
                    />
                    <UiButton
                        onClick={onChangeStatusInExploitation}
                        className={cls.buttons}
                        btnColor="secondary"
                        btnText={t('PastStartDateWarningStep.Footer.UiButton.changeStatus')}
                    />
                    <a href={routable.getRoute('toSchedule')}>
                        <UiButton
                            startIcon={<Icon iconName="goLink" />}
                            variant="text"
                            btnText={t('PastStartDateWarningStep.Footer.UiButton.redirect')}
                        />
                    </a>
                </Flex>
            </CustomModal.Footer>
        </>
    );
};
